'use strict';

var _ = require('lodash');
var UserSecureIsAllowedComponent = function UserSecureIsAllowedComponent(userSecureService) {
  return {
    restrict: 'A',
    priority: -1,
    scope: {
      expected: '@?',
      ngDisabled: '=?',
      multiplePermission: '=?'
    },
    link: function link($scope, $element, $attr) {
      var workFlow = $attr.rmIsAllowedComponent;
      function disableElement() {
        $scope.$evalAsync(function () {
          $attr.$set('disabled', 'disabled');
          $element.attr('disabled', 'disabled');
          if ($element.prop('type') === 'radio') {
            $attr.$set('value', 'false');
            $element.attr('value', 'false');
          }
        });
      }
      function checkPermission() {
        if ($scope.multiplePermission) {
          var result = false;
          //or
          if (_.isObject($scope.multiplePermission)) {
            _.forOwn($scope.multiplePermission, function (expected, component) {
              result = result || userSecureService.hasAuthorization(component, expected);
            });
            return !result && disableElement();
          }

          //and
          if (_.isArray($scope.multiplePermission)) {
            result = true;
            _.forEach($scope.multiplePermission, function (permission) {
              result = result && !userSecureService.hasAuthorization(permission.component, permission.expect);
            });
            return !result && disableElement();
          }
          return disableElement();
        }
        if (!workFlow) {
          return true;
        }
        var expected = $scope.expected;
        if (!userSecureService.hasAuthorization(workFlow, expected)) {
          disableElement();
        }
      }
      $scope.$watch('ngDisabled', function () {
        checkPermission();
      });
      checkPermission();
    }
  };
};
UserSecureIsAllowedComponent.$inject = ['UserSecureService'];
module.exports = UserSecureIsAllowedComponent;